<a [routerLink]="['/']" href="javascript:void(0)">
  @if (logo?.visible) {
    @if (logo?.options?.["logo"]?.visible) {
      <img
        [src]="logo?.options?.['logo']?.value"
        class="img-fluid logo-img"
        alt="logo"
      />
    } @else if (logo?.options?.["title"]?.visible) {
      <h2 class="f-w-600 logo-text">{{ logo?.options?.["title"]?.value }}</h2>
    }
  }
</a>
